/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning': {
    width: 16,
    height: 16,
    viewBox: '0 0 249.55 249',
    data: '<path pid="0" d="M237.05 249H12.48a12.47 12.47 0 01-11.16-18.06l112.3-224.6c4.22-8.45 18.09-8.45 22.32 0l112.3 224.6A12.48 12.48 0 01237.05 249zM32.67 224h184.22L124.78 39.82z"/><path pid="1" d="M112.3 99.27h24.96v74.87H112.3z"/><circle pid="2" cx="124.78" cy="199.09" r="15.6"/>'
  }
})
